import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';

import styles from './SocialLink.style';

const theme = (outerTheme) => ({
  ...outerTheme,
  overrides: {
    MuiSvgIcon: {
      root: {
        width: 18,
      },
    },
  },
});

function SocialLink(props) {
  const { href, children, classes } = props;

  return (
    <MuiThemeProvider theme={theme}>
      <a
        className={classes.socialLink}
        href={href}
        rel="noopener noreferrer"
        target="_blank">
        {children}
      </a>
    </MuiThemeProvider>
  );
}

export default withStyles(styles)(SocialLink);
